import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Card } from "react-bootstrap";
import illusEspaces from "../../../assets/images/illusEspaces.jpg";
import ModalDetailSpace from "./ModalDetailSpace";
import { AiOutlineStar } from "react-icons/ai";
import { VscFileBinary } from "react-icons/vsc";
import { BsCalendar2Week } from "react-icons/bs";
import { usagesSalles } from "../../../constants/usagesSalles";
import { usagesDigital } from "../../../constants/usagesDigital";
import { MdLocationOn } from "react-icons/md";
import { FaTag } from "react-icons/fa";
import { RiComputerLine } from "react-icons/ri";
import { GrGroup } from "react-icons/gr";

const ComponentEspace = (props) => {
  const { t } = useTranslation();
  const { espace, filtreUsagesActif, calendrier, usagesDiponibles } = props;
  const [showDetails, setShowDetails] = useState(false);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  const usesSalles = usagesSalles;
  const usesDigital = usagesDigital;

  const handleShowDetails = () => {
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
  };

  const pointCouleur = (usages, usage, withUsage = null) => {
    let usageTrouve = usages.filter((item) => item.tag === usage)[0];

    if (usageTrouve)
      return (
        <span key={usage}>
          <span className="pointCouleurUsage" style={{ backgroundColor: usageTrouve.color }}></span>
          {withUsage !== null ? withUsage : ""}
        </span>
      );

    return null;
  };

  const afficheUtilisations = (usages = null, usage = null, withUsage = null) => {
    let usageTrouve = usages.filter((item) => item.tag === usage)[0];
    if (usageTrouve) return <span key={usage}>{withUsage}, </span>;

    return null;
  };

  const AfficheUsage = ({ idUsage = null }) => {
    if (idUsage) {
      let usagePrincipalTrouve = usagesDiponibles.filter((item) => item._id === idUsage);
      if (usagePrincipalTrouve && usagePrincipalTrouve.length > 0)
        return <span className="me-1">{usagePrincipalTrouve[0].nom}</span>;
    }
    return null;
  };

  useEffect(() => {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const actionDemandee = urlParams.get("action");
      if (actionDemandee === espace._id) {
        handleShowDetails();
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="d-flex flex-column" id={"espace_" + espace._id}>
      <span className="componentRoomLocalisation ms-2 d-flex align-items-center">
        <MdLocationOn size="1.5em" color="#BBBBBB" />
        {espace.localisation.nom}
      </span>
      <Card
        className="componentRoom ms-2 me-2 mb-2 flex-grow-1"
        onClick={() => {
          handleShowDetails();
        }}
        role="button"
      >
        <Card.Img
          variant="top"
          src={
            espace.cardPic
              ? process.env.REACT_APP_URL_EXPRESS + "images/space/small/" + espace.cardPic
              : illusEspaces
          }
          style={{ height: 85 }}
        />
        <Card.Body className="d-flex flex-column">
          <div className="flex-grow-1">
            <Card.Title>{espace.nom}</Card.Title>
            <Card.Text>
              {espace.usages && espace.usages.length > 0 && (
                <>
                  <FaTag size="1em" color="#BBBBBB" className="me-1" />
                  {espace.usages.map((idUsage, index) => (
                    <AfficheUsage key={idUsage} idUsage={idUsage} />
                  ))}
                </>
              )}

              <br />
              <span>
                {espace.mainUse !== "null" && espace.mainUse
                  ? afficheUtilisations(
                      usesSalles,
                      espace.mainUse,
                      t("commun.usagesSalles." + espace.mainUse)
                    )
                  : ""}

                {espace.secondaryUses.sort().map((use, index) => {
                  return afficheUtilisations(usesSalles, use, t("commun.usagesSalles." + use));
                })}
              </span>

              {(espace.mainUseDigital !== "null" && espace.mainUseDigital) ||
              espace.secondaryUsesDigital.length > 0 ? (
                <>
                  <br />
                  <RiComputerLine size="1em" color="#BBBBBB" className="me-1" />
                </>
              ) : (
                ""
              )}
              <span>
                {espace.mainUseDigital !== "null" && espace.mainUseDigital ? (
                  <span className="me-1">
                    {afficheUtilisations(
                      usesDigital,
                      espace.mainUseDigital,
                      t("commun.usagesDigital." + espace.mainUseDigital)
                    )}{" "}
                  </span>
                ) : (
                  ""
                )}

                {espace.secondaryUsesDigital.sort().map((use, index) => {
                  return afficheUtilisations(usesDigital, use, t("commun.usagesDigital." + use));
                })}
              </span>

              {espace.capacite !== 0 && (
                <span>
                  <br />
                  <GrGroup size="1em" color="#BBBBBB" className="me-1" />
                  {espace.capacite
                    ? espace.capacite === 1
                      ? espace.capacite + " " + t("public.pageTierslieux.personne")
                      : espace.capacite + " " + t("public.pageTierslieux.personnes")
                    : "-"}
                </span>
              )}

              {/*
              {espace.mainUse !== "null" && espace.mainUse
                ? pointCouleur(
                    usesSalles,
                    espace.mainUse,
                    t("commun.usagesSalles." + espace.mainUse)
                  )
                : " -"}
              {espace.secondaryUses.sort().map((use, index) => {
                return pointCouleur(usesSalles, use);
              })}

              <br />
              {espace.mainUseDigital !== "null" && espace.mainUseDigital
                ? pointCouleur(
                    usesDigital,
                    espace.mainUseDigital,
                    t("commun.usagesDigital." + espace.mainUseDigital)
                  )
                : " -"}

              {espace.secondaryUsesDigital.sort().map((use, index) => {
                return pointCouleur(usesDigital, use);
              })} */}
            </Card.Text>
          </div>
          {espace.email && ReduxInstance.urlReservationSalle !== "" && (
            <div className="text-center">
              {espace.emailResponsable ? (
                <Button
                  className="buttonCard"
                  href={
                    "mailto:" +
                    espace.emailResponsable +
                    "?Subject=Demande de réservation de la salle : " +
                    espace.nom
                  }
                  rel="noreferrer"
                >
                  {t("public.boutons.je_commande")}
                </Button>
              ) : (
                <Button
                  className="buttonCard"
                  href={ReduxInstance.urlReservationSalle}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("public.boutons.je_reserve")}
                </Button>
              )}
            </div>
          )}
        </Card.Body>
      </Card>
      <ModalDetailSpace
        espace={espace}
        show={showDetails}
        handleClose={handleCloseDetails}
        calendrier={calendrier}
        usagesDisponibles={usagesDiponibles}
      />
    </div>
  );
};

export default ComponentEspace;
